import { Grid2, Typography, Button,FormHelperText,FormControl,TextField } from "@mui/material";
import referpic from "../../../ui-utils/latestPics/refersvg.svg";
import ReferMobileViewStyles from "./ReferMobileView.module.css";
import OtpInput from "react-otp-input";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useState } from "react";
import axios from "axios";
import { backendHosts } from "../../../ui-utils/apiConfig";
import { useLanguage } from "../../../Context/LangContext";
import en from "../../../i18n/English/Home/refer.json";
import hi from "../../../i18n/Hindi/Home/refer.json";
import kn from "../../../i18n/Kannada/Home/refer.json";
import ma from "../../../i18n/Marathi/Home/refer.json";
import gu from "../../../i18n/Gujarati/Home/refer.json";
import { fontWeight } from "@mui/system";
export default function ReferMobileView() {
    const [open,setOpen]=useState(false)
    const [refcode, setRefCode] = useState("");
    const [mobile,setMobile]=useState("");
    const [isValid, setIsValid] = useState(false);
    const [linkPage, setLinkPage] = useState(false);
    const [link, setLink] = useState("")
    const [refresData, setRefResData] = useState(null);
    const [errMsg, setErrMsg] = useState("");
    const [otp, setOtp] = useState("");


  const { language } = useLanguage();
  const translations = { en, hi, kn, gu, ma };
  const t = translations[language] || translations.en;

  const handleValidate = async () => {
    if (!refcode) {
      setErrMsg("Client ID is required.");
      return;
    }
    const payload = {
      data: {
        client_id: refcode
      }
    }
    // setIsValid(true)
    try {
      const respone = await axios.post(`${backendHosts.ADMIN}/api/public/otp`, payload)
      if (respone.data.data?.data?.success) {
        setErrMsg("")
        setRefResData(respone.data?.data?.data)
        setMobile(respone.data?.data?.data?.mobile)
        setIsValid(true)
      } else {
        setErrMsg("Please enter a valid client ID")
      }
    } catch (err) {
      console.log(err)
    }

  }



  const hadleCancelRefferal = () => {
    setOpen(false)
    setIsValid(false)
    setMobile("")
    setOtp("")
    setErrMsg("")
    setRefCode("")
  };

  const handleverifyReferralOTP = async () => {

    if (!otp) {
      setErrMsg("OTP is required.");
      return;
    }
    const payload = {
      data: {
        client_id: refcode,
        mobile: mobile,
        otp: otp
      }
    }
    try {
      const respone = await axios.post(`${backendHosts.ADMIN}/api/public/otp/verify`, payload)
      if (respone.data.data?.data?.success) {
        setLinkPage(true)
        setLink(respone.data?.data?.data?.link)
        setErrMsg("")
      } else {
        setErrMsg(respone.data.data?.data?.message)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(
      link
    );
    }
  return (
    <>
      <Grid2 className={ReferMobileViewStyles.Mobile_ref_card1}>
        {
            linkPage ? <>
            <Grid2 className={ReferMobileViewStyles.linkCard}>


            <Typography className={ReferMobileViewStyles.Mobile_refcard_txt}>
              Find your link below
            </Typography>
            < Grid2 className={ReferMobileViewStyles.ref_card6}>
              <Grid2 className={ReferMobileViewStyles.ref_card3}>
                <Typography className={ReferMobileViewStyles.reflinktxt}>
                    {link}
              </Typography>

              <Grid2
                style={{
                  width: "10%",
                  marginRight: "10px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={handleCopy}
              >
                <Grid2
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                      <FileCopyIcon style={{
                        color: "#ffffff"
                      }} />
                </Grid2>
                <Grid2
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: "#ffffff",
                      fontSize: "11px",
                      fontFamily: "Inter700",
                    }}
                  >
                    copy
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
            </Grid2>
            </> :<>
            <h1 className={ReferMobileViewStyles.Mobile_refcard_txt}>
              {/* Referral program */}
                {t.referralProgram}
            </h1>

            {
              open ? <>
                {
                  isValid ? <>
                    <Grid2 className={ReferMobileViewStyles.inputCard}>
                      {/* <Typography className={ReferMobileViewStyles.otpTxt}>Enter OTP</Typography> */}

                      <Grid2
                        style={{
                          width: "100%",

                        }}
                      >
                        <Grid2 className={ReferMobileViewStyles.optinnercard}>
                          <Typography className={ReferMobileViewStyles.otpSubTxt}>
                            Please provide us the OTP, {refresData?.message} linked with
                            client code {refcode}{" "}
                            {/* Please provide us the OTP, sent to your <br></br>
phone number ******7708 linked with client code AAA384 */}
                            {/* {this.state.mobilenumber.substring(6, 10)}  */}
                            {/* {this.state.clentid.toString().toUpperCase()} */}
                          </Typography>
                          <Grid2
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            <OtpInput
                              numInputs={4}
                              value={otp}
                              shouldAutoFocus={true}
                              inputStyle={{
                                backgroundColor: "transparent",
                                width: "40px",
                                height: "40px",
                                border: "none",
                                marginRight: "5px",
                                color: "#ffffff",
                                fontSize: "20px",
                                fontFamily: "Inter500",
                                borderBottom: "1px solid #ffffff",
                              }}
                              containerStyle={{
                                justifyContent: "center",
                                borderBottom: "10",
                              }}
                              renderInput={(props) => <input {...props} />}
                              // onChange={(e) => setOtp(e.target.value)}
                              onChange={(value) => setOtp(value)}
                            />
                          </Grid2>
                            {errMsg && (
                              <FormHelperText sx={{ color: "#e93333 !important", fontFamily: "Inter400 !important", fontSize: "16px !important", display: "flex", justifyContent: "center", alignContent: "center", marginTop: "10px" }}>
                                {errMsg}
                              </FormHelperText>
                            )}
                        </Grid2>
                      </Grid2>
                      <Grid2 className={ReferMobileViewStyles.inputButCard}>
                          <Button className={ReferMobileViewStyles.inputbut} onClick={hadleCancelRefferal}>
                          Cancel
                        </Button>
                          <Button className={ReferMobileViewStyles.inputbut} onClick={handleverifyReferralOTP}>
                          Submit
                        </Button>
                      </Grid2>
                    </Grid2>
                  </> : <>
                    <Grid2 className={ReferMobileViewStyles.inputCard}>
                      <FormControl className={ReferMobileViewStyles.ref_card7} variant="standard">
                        <TextField
                          variant="standard" // or 'outlined', 'filled' based on your design
                              label={t.enterClientCode} // The label text
                          value={refcode}
                          sx={{
                            // Label styles
                            "& .MuiInputLabel-root": {
                              color: "#FFFFFF", // Default label color
                              fontFamily: "Inter400 !important", // Label font family
                              fontSize: "20px", // Default label font size
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#FFFFFF", // Label color when focused
                              fontSize: "22px", // Optional: Increase font size when focused
                            },
                            "& .MuiInputLabel-root.Mui-error": {
                              color: "#FFFFFF", // Label color in case of error
                            },
                            "& .MuiInput-underline:before": {
                              borderBottomColor: "#FFFFFF",
                            },
                            "& .MuiInput-underline:hover:before": {
                              borderBottomColor: "#FFFFFF",
                            },
                            "& .MuiInput-underline:after": {
                              borderBottomColor: "#FFFFFF",
                            },

                            "& .MuiInputBase-input": {
                              color: "#FFFFFF",
                              fontFamily: "Inter400",
                              fontSize: "20px",
                              padding: "5px 0",
                            },
                          }}
                          InputLabelProps={{
                            style: {
                              fontFamily: "Inter400 !important", // Ensures the font family applies
                              fontSize: "20px", // Custom label font size

                            },
                          }}
                          onChange={(e) => setRefCode(e.target.value)}
                        />

                        {errMsg && (
                              <FormHelperText sx={{ color: "#e93333 !important", fontFamily: "Inter400 !important", fontSize: "16px !important", }}>
                            {errMsg}
                          </FormHelperText>
                        )}
                      </FormControl>
                      <Grid2 className={ReferMobileViewStyles.inputButCard}>
                            <Button className={ReferMobileViewStyles.inputbut} onClick={() => {
                              setOpen(false)
                              setErrMsg("")
                              setRefCode("")
                         }}>
                              {t.cancel}
                        </Button>
                            <Button className={ReferMobileViewStyles.inputbut} onClick={handleValidate}>
                              {t.validate}
                        </Button>
                      </Grid2>
                    </Grid2>

                  </>
                }
              </> : <>
                <Grid2 className={ReferMobileViewStyles.mobile_pic_card}>
                  <img
                    src={referpic}
                    alt="referall"
                    className={ReferMobileViewStyles.Mobile_refer_pic}
                  />
                </Grid2>
                <div>
                  {/* <Typography className={ReferMobileViewStyles.Mobile_refcard_txt1}>
                    Tradeboss offers Referral Program for all their valuable patrons. This program enables the patrons to be part of growth of Bullforce and ensures a steady income. The patrons are entitled to get
                    <span className={ReferMobileViewStyles.mobrefsub_text2}> ₹3 </span> per executed order for every order placed by their respective affiliates.
                  </Typography> */}
                  <Typography className={ReferMobileViewStyles.Mobile_refsubtitle}>
                    {/* This involves 2 very simple steps. */}
                    {t.thisInvolvesSteps}
                  </Typography>

                  <Typography
                    className={ReferMobileViewStyles.Mobile_refcard_txt1}
                  >
                    <span className={ReferMobileViewStyles.Mobile_refsub_text} style={{fontWeight:"600"}}>
                      {" "}
                      {/* Generate your referral code */}
                          {t.generateReferralCode}
                    </span>{" "}
                    {/* by keying your account number and share the link within your
                    network. */}
                        {t.text}
                  </Typography>

                  <Grid2 className={ReferMobileViewStyles.mobile_button_card}>
                    <Button
                      className={ReferMobileViewStyles.Mobile_referral_but2} onClick={() => { setOpen(true) }}>
                      {/* Refer */}
                          {t.refer}
                    </Button>
                  </Grid2>
                </div>
              </>
            }
            </>
        }


      </Grid2>
    </>
  );
}
